/**
 * Text-to-Speech API
 */

import { executeRequest } from './hooks/useApiQuery';

export type TTSFormat = 'mp3' | 'wav' | 'ogg';

export interface TTSResponse {
  success: boolean;
  provider?: string;
  format?: TTSFormat;
  mimeType?: string;
  audioBase64?: string;
  error?: string;
}

export async function synthesizeSpeech(text: string, format: TTSFormat = 'mp3'): Promise<TTSResponse> {
  return executeRequest<TTSResponse>({
    url: '/tts',
    method: 'POST',
    body: {
      text,
      format,
    },
  });
}
